
  <app-navbar-style-one></app-navbar-style-one>
  <app-navbar-style-two></app-navbar-style-two>
    <div class="container">
     <div class="video-container">
      <div class="container text-center">
        <h1>Latest Video Posts</h1>
        <button mat-raised-button color="primary" (click)="openVideoPopup()">Add Video</button>
      </div>
     </div>
    <div class="gallery-container">
      <mat-tab-group>
        <mat-tab *ngFor="let category of videoCategories" [label]="category.name">
          <div align="center" *ngIf="gifLoader">
            <img height="100px" width="100px"
                src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="medeil gif"
                loading="lazy">
           </div>
          <div class="gallery-wrapper mt-2">
            <div *ngFor="let video of getVideosByCategory(category.id)" class="gallery-item">
              <div class="video-card">
                <div class="video-preview">
                  <!-- <video controls [src]="video.videolink"></video> -->
                  <video *ngIf="isDirectVideo(video.videolink)" controls width="100%">
                    <source [src]="video.embedUrl" type="video/mp4">
                    Your browser does not support the video tag.
                  </video>
                  <!-- For embedded videos (YouTube, Facebook, Instagram, Twitter) -->
                  <iframe *ngIf="isEmbed(video.videolink)" [src]="video.embedUrl" width="100%" height="160"
                    frameborder="0" allowfullscreen></iframe>
                </div>

                <div class="video-info">
                  <h2 class="video-title">{{ video.title }}</h2>
                  <p class="video-description">{{ video.description }}</p>

                  <div class="video-meta">
                    <span class="date">{{ video.publishdate | date }}</span>
                  </div>
                  <a (click)="viewPage(video)" class="read-more">..Read More</a>
                  <div class="video-actions">
                    <i class="fa fa-edit edit-icon" (click)="edit(video)"></i>
                    <i class="fa fa-trash delete-icon" (click)="deletevideo(video.id)"></i>
                    <!-- <i class="fa fa-share-alt share-icon"></i> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    </div>






  <app-footer-style-two></app-footer-style-two>